import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import helper from "../../../components/helper/index"
import { FiChevronDown } from "react-icons/fi";
import { MyTaskData } from "../../../components/Datas";
import { BsChevronRight, BsPlus, BsCircleFill, BsPuzzleFill } from "react-icons/bs";
import PopupMaterial from "./PopupMaterial";
import EditMaterialModel from "../../../components/Modals/EditMaterialModel";

const MaterialTable = ({ data, action }) => {
  const [perPage, setPerPage] = useState(250);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [showEditMaterialModel, setShowEditMaterialModel] = useState(false);



  const dataRaw = [
    {
      employee: "Employee 1",
      date: "2023-06-22",
      total: "100.00",
      task: "Task 1",
      finishedTasks: 5,
      totalPieceRate: "50.00",
    },
  ];

  const openEditMaterialModel = () => {
    setShowEditMaterialModel(true);
  }
  const closeEditMaterialModel = () => {
    setShowEditMaterialModel(false);
  }

  const openEditUpdateModel = () => {
    setIsPopupOpen(true);
  }
  const closeEditUpdateModel = () => {
    setIsPopupOpen(false);
  }

  return (
    <>
      {dataRaw.map((item, index) => (
        <>
          <div className="bg-gray-100 rounded-lg my-2 p-5">
            <Link onClick={openEditUpdateModel} className="flex items-center justify-between ">
              <div className="flex items-center">
                <BsPuzzleFill className="items-center text-teal-500" size={15} />
                <div className="ml-4">
                  <p className="text-gray-500 font-bold">
                    Wheel Excavator 21
                  </p>
                </div>
              </div>
              <div className="flex items-center">
                <span className="px-2">2 ml</span>
                {/* <span>status</span> */}
                <Button color="link" className="text-teal-500 p-0">
                  <BsChevronRight size={24} />
                </Button>
              </div>
            </Link>
          </div>
        </>
      ))}

      {/* <span>Create a new invoice for this case</span> */}
      <div className="flex justify-center mt-3">
        <Button
          color="primary"
          onClick={openEditMaterialModel}
          className="flex items-center bg-teal-500 text-white px-4 py-2 rounded-md border-0 hover:bg-teal-600"
        >
          <BsPuzzleFill size={15} className="mr-2" />
          Edit
        </Button>
      </div>

      <EditMaterialModel
        isOpen={showEditMaterialModel} 
        onClose={closeEditMaterialModel} 
      />

      <PopupMaterial
        isOpen={isPopupOpen} 
        onClose={closeEditUpdateModel} 
      />
    </>
  );
};

export default MaterialTable;
